<template>
  <!-- Please wait component -->
  <div class="loading-text">
    <p>Please wait</p>
    <div v-bind:class="{ loading: loading }"></div>
  </div>
</template>
<script>
export default {
  name: 'Loader',
  data() {
    return {
      loading: true,
    };
  },
};
</script>
<style scoped>
@keyframes buttonLoadingSpinner {
    from {
      transform: rotate(0turn);
    }
    to {
      transform: rotate(1turn);
    }
  }

  .loading-text {
    position: relative;
    display: flex;
    align-items: center;
    margin-top: 50px;
    color: white;
    justify-content: center;
  }
  .loading-text p {
    font-size: 12px;
  }
  .loading::after {
    content: "";
    position: absolute;
    width: 100px;
    height: 100px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    border: 4px solid transparent;
    border-top-color: var(--white);
    border-right-color: var(--white);
    border-radius: 50%;
    animation: buttonLoadingSpinner 1s linear infinite;
  }

</style>
